module.exports = __webpack_public_path__ + "static/media/dessert.0f9c941a.png";